<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAdminStore } from '@/stores'
import { useTheme } from '@/composables/useTheme'

const router = useRouter()
const adminStore = useAdminStore()
const { resolved, toggle } = useTheme()

const logoSrc = computed(() =>
  resolved.value === 'dark' ? '/logo-dark.svg' : '/logo.svg'
)

function handleLogout(): void {
  adminStore.logout()
  router.push('/login')
}
</script>

<template>
  <header class="admin-header">
    <div class="admin-header__brand" @click="router.push('/')">
      <img :src="logoSrc" alt="阿旺运营后台" class="admin-header__logo">
      <span class="admin-header__title">阿旺运营后台</span>
    </div>
    <div class="admin-header__actions">
      <button class="admin-header__theme" @click="toggle">
        {{ resolved === 'dark' ? '🌙' : '☀️' }}
      </button>
      <span v-if="adminStore.user" class="admin-header__user">
        {{ adminStore.user.displayName }}
      </span>
      <button class="admin-header__logout" @click="handleLogout">退出</button>
    </div>
  </header>
</template>

<style scoped lang="scss">
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--aw-space-6);
  background-color: var(--aw-bg-base);
  border-bottom: 1px solid var(--aw-border-default);

  &__brand {
    display: flex;
    align-items: center;
    gap: var(--aw-space-3);
    cursor: pointer;
  }

  &__logo {
    width: 32px;
    height: 32px;
    border-radius: var(--aw-radius-md);
    object-fit: cover;
  }

  &__title {
    font-size: var(--aw-text-md);
    font-weight: var(--aw-font-semibold);
    color: var(--aw-text-primary);
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--aw-space-4);
  }

  &__theme {
    padding: var(--aw-space-1) var(--aw-space-2);
    border: none;
    border-radius: var(--aw-radius-sm);
    background-color: transparent;
    font-size: var(--aw-text-md);
    cursor: pointer;
    transition: all var(--aw-duration-fast);

    &:hover {
      background-color: var(--aw-bg-muted);
    }
  }

  &__user {
    font-size: var(--aw-text-sm);
    color: var(--aw-text-secondary);
  }

  &__logout {
    padding: var(--aw-space-1) var(--aw-space-3);
    border: none;
    border-radius: var(--aw-radius-sm);
    background-color: transparent;
    color: var(--aw-text-secondary);
    font-size: var(--aw-text-sm);
    cursor: pointer;
    transition: all var(--aw-duration-fast);

    &:hover {
      background-color: var(--aw-bg-muted);
      color: var(--aw-danger-500);
    }
  }
}
</style>
